import React from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { headings } from '../../utils/submissions';
import SubmissionsTableHead from './SubmissionsTableHead';
import SubmissionsTableRow from './SubmissionsTableRow';
import { ReactComponent as Spinner } from 'static/icons/spinner.svg';
import SubmissionTableSpinner from './SubmissionTableSpinner';

export default function SubmissionsTable({
  headClass,
  headingClass,
  emptyContent,
  loading,
  submissionsData,
  fetchMoreSubmissions,
  hasMore
}) {
  return (
    <table className="divide-y divide-[#1D2939] w-full">
      <InfiniteScroll
        dataLength={submissionsData.length}
        scrollableTarget="pageContainer"
        next={fetchMoreSubmissions}
        hasMore={hasMore}
        loader={!loading && <SubmissionTableSpinner />}>
        {loading ? (
          <SubmissionTableSpinner />
        ) : (
          <div className="overflow-hidden">
            <SubmissionsTableHead
              headings={headings}
              headingClass={headingClass}
              headClass={headClass}
            />
            <tbody className="relative w-full">
              {submissionsData?.map((item, index) => (
                <SubmissionsTableRow
                  item={item || {}}
                  key={item?._id}
                  isLast={index === submissionsData.length - 1}
                  index={index}
                />
              ))}
            </tbody>
          </div>
        )}
      </InfiniteScroll>
    </table>
  );
}
